export default __webpack_public_path__ + "static/media/footer__bg.13485d22.png";